import { useStoneDeviceList } from '@/core/domain/stone/devices/devices.hooks';
import { StoneAccount } from '@/core/domain/stone/stoneAccount/stoneAccount.types';
import { Col, Empty, Modal, Row, Skeleton } from 'antd';
import { useEffect, useState } from 'react';
import DeviceItem from './DeviceItem';
import { applyCpfCnpjMask } from '@/utils/mask';
import { StoneDevice } from '@/core/domain/stone/devices/devices.types';
import { Group } from '@/components/_common';

interface Props {
  open: boolean;
  onClose: VoidFunction;
  stoneAccount?: StoneAccount;
  setDevice: (device: StoneDevice) => void;
  device?: StoneDevice;
}

export default function StoneDevicesSelectModal(props: Props) {
  const [device, setDevice] = useState<StoneDevice>();

  useEffect(() => {
    setDevice(props.device);
  }, [props.device]);

  const stoneDeviceList = useStoneDeviceList(
    {
      isActive: true,
      companyId: props.stoneAccount?.companyId,
    },
    props.open,
  );

  function handleClose() {
    setDevice(undefined);
    props.onClose();
  }

  function handleOk() {
    if (device) {
      props.setDevice(device);
    }
  }

  return (
    <Modal
      width={600}
      open={props.open}
      onCancel={handleClose}
      title="Seleção de dispositivos"
      okText="Confirmar seleção"
      okButtonProps={{ disabled: !device }}
      onOk={handleOk}
      destroyOnClose
      maskClosable={false}
    >
      <Group gap={10}>
        <strong>Conta:</strong>
        {props.stoneAccount?.accountId || '-'}
      </Group>

      <Group gap={10}>
        <strong>Empresa:</strong>
        {props.stoneAccount?.accountSocialReason || '-'}
      </Group>

      <Group gap={10}>
        <strong>CNPJ:</strong>
        {applyCpfCnpjMask(props.stoneAccount?.accountCnpj || '') || '-'}
      </Group>

      <Row gutter={[24, 24]} style={{ marginTop: 24 }} key={Number(props.open)}>
        {stoneDeviceList.isLoading &&
          Array.from({ length: 4 }).map((_, i) => (
            <Col key={i} span={24}>
              <Skeleton.Button
                active
                block
                style={{ height: 100, borderRadius: 12 }}
              />
            </Col>
          ))}

        {props.open &&
          (!!stoneDeviceList.data?.length ? (
            stoneDeviceList.data?.map((item) => (
              <Col key={item.id} span={24}>
                <DeviceItem
                  device={item}
                  active={item.id === device?.id}
                  onClick={() => setDevice(item)}
                  companyId={props.stoneAccount?.companyId}
                  key={stoneDeviceList.dataUpdatedAt}
                />
              </Col>
            ))
          ) : (
            <Empty
              description={
                <>
                  <strong>Não há dispositivos</strong>
                  <p>
                    Verifique se as configurações dos dispositivos estão
                    ativados, ou se há dispositivos cadastrados.
                  </p>
                </>
              }
            />
          ))}
      </Row>
    </Modal>
  );
}
